import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getCliente, updateCliente, getContactos, createContacto, updateContacto, deleteContacto, getCotizaciones, getFacturas, getRemisiones } from '../services/api';
import HistorialSiigo from '../components/HistorialSiigo';

const fmt = (n) => new Intl.NumberFormat('es-CO', { style:'currency', currency:'COP', minimumFractionDigits:0 }).format(n || 0);
const fdate = (d) => d ? new Date(d).toLocaleDateString('es-CO') : '—';
const EC = { aprobada:'#10b981', enviada:'#3b82f6', borrador:'#94a3b8', rechazada:'#ef4444', vencida:'#f59e0b', facturada:'#8b5cf6', pagada:'#10b981', emitida:'#3b82f6', anulada:'#ef4444' };

export default function ClienteDetalle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [cliente, setCliente] = useState(null);
  const [contactos, setContactos] = useState([]);
  const [cotis, setCotis] = useState([]);
  const [facturas, setFacturas] = useState([]);
  const [remis, setRemis] = useState([]);
  const [tab, setTab] = useState('cotizaciones');
  const [sTipo, setSTipo] = useState('factura');
  const [ctForm, setCtForm] = useState(null); // null = oculto; {} = formulario abierto (con id = edición)
  const INIT_CT = { nombre:'', cargo:'', email:'', telefono:'' };
  const [editCli, setEditCli] = useState(null); // objeto cliente en edición o null
  const [savingCli, setSavingCli] = useState(false);

  const loadContactos = () => getContactos(id).then(r => setContactos(r.data)).catch(() => setContactos([]));
  const guardarContacto = async () => {
    if (!ctForm.nombre) return alert('El nombre es requerido');
    try {
      if (ctForm.id) await updateContacto(id, ctForm.id, ctForm);
      else await createContacto(id, ctForm);
      setCtForm(null); loadContactos();
    } catch (e) { alert(e.response?.data?.error || 'Error al guardar contacto'); }
  };
  const borrarContacto = async (cid) => {
    if (!window.confirm('¿Eliminar este contacto?')) return;
    try { await deleteContacto(id, cid); loadContactos(); } catch { alert('Error al eliminar'); }
  };
  const guardarCliente = async () => {
    if (!editCli.razon_social) return alert('La razón social es requerida');
    setSavingCli(true);
    try {
      const { data } = await updateCliente(id, editCli);
      setCliente(data); setEditCli(null);
    } catch (e) { alert(e.response?.data?.error || 'Error al guardar cliente'); }
    finally { setSavingCli(false); }
  };

  useEffect(() => {
    getCliente(id).then(r => setCliente(r.data)).catch(() => {});
    loadContactos();
    getCotizaciones({ cliente_id: id }).then(r => setCotis(r.data)).catch(() => {});
    getFacturas({ cliente_id: id }).then(r => setFacturas(r.data)).catch(() => {});
    getRemisiones({ cliente_id: id }).then(r => setRemis(r.data)).catch(() => {});
  }, [id]);

  const totalFacturado = facturas.reduce((s, f) => s + Number(f.total || 0), 0);
  const cartera = facturas.reduce((s, f) => s + Number(f.saldo || 0), 0);

  const TABS = [
    { k:'cotizaciones', label:`📋 Cotizaciones (${cotis.length})` },
    { k:'facturas',     label:`🧾 Facturas (${facturas.length})` },
    { k:'remisiones',   label:`📦 Remisiones (${remis.length})` },
    { k:'siigo',        label:`📄 Histórico Siigo` },
  ];

  if (!cliente) return <div style={{ color:'#64748b' }}>Cargando…</div>;

  return (
    <div>
      <button style={s.back} onClick={() => navigate('/clientes')}>← Clientes</button>
      <div style={{ ...s.head, display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
        <div>
          <h1 style={s.h1}>{cliente.razon_social}</h1>
          <p style={s.sub}>NIT {cliente.nit}</p>
        </div>
        <button style={s.btnSm} onClick={() => setEditCli({ ...cliente })}>✏️ Editar cliente</button>
      </div>

      {/* Resumen (ancho completo, arriba) */}
      <div style={{ ...s.card, marginBottom: 16 }}>
        <h3 style={s.cardTitle}>Resumen</h3>
        <div style={s.stats}>
          <Stat label="Cotizaciones" value={cotis.length} color="#7dd3fc" />
          <Stat label="Facturas" value={facturas.length} color="#a78bfa" />
          <Stat label="Facturado" value={fmt(totalFacturado)} color="#10b981" small />
          <Stat label="Cartera" value={fmt(cartera)} color={cartera > 0 ? '#f59e0b' : '#64748b'} small />
        </div>
      </div>

      {/* Datos + Contactos en la misma fila */}
      <div style={{ ...s.topGrid, marginBottom: 16 }}>
        <div style={s.card}>
          <h3 style={s.cardTitle}>Datos</h3>
          <Info label="Email" value={cliente.email} />
          <Info label="Teléfono" value={cliente.telefono} />
          <Info label="Ciudad" value={cliente.ciudad} />
          <Info label="Dirección" value={cliente.direccion} />
          <Info label="Contacto" value={cliente.contacto_nombre} />
        </div>

        {/* Contactos (2ª columna) */}
        <div style={s.card}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: 10 }}>
          <h3 style={{ ...s.cardTitle, margin: 0 }}>Contactos ({contactos.length})</h3>
          {ctForm === null && <button style={s.btnSm} onClick={() => setCtForm({ ...INIT_CT })}>+ Agregar contacto</button>}
        </div>

        {ctForm !== null && (
          <div style={{ background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:12, marginBottom:12 }}>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
              <div><label style={s.lbl}>Nombre *</label><input style={s.inp} value={ctForm.nombre} onChange={e => setCtForm({ ...ctForm, nombre:e.target.value })} /></div>
              <div><label style={s.lbl}>Cargo</label><input style={s.inp} value={ctForm.cargo} onChange={e => setCtForm({ ...ctForm, cargo:e.target.value })} /></div>
              <div><label style={s.lbl}>Email</label><input style={s.inp} type="email" value={ctForm.email} onChange={e => setCtForm({ ...ctForm, email:e.target.value })} /></div>
              <div><label style={s.lbl}>Teléfono</label><input style={s.inp} value={ctForm.telefono} onChange={e => setCtForm({ ...ctForm, telefono:e.target.value })} /></div>
            </div>
            <div style={{ display:'flex', gap:8, justifyContent:'flex-end', marginTop:10 }}>
              <button style={s.btnSec} onClick={() => setCtForm(null)}>Cancelar</button>
              <button style={s.btnSm} onClick={guardarContacto}>{ctForm.id ? 'Actualizar' : 'Guardar'}</button>
            </div>
          </div>
        )}

        {contactos.length === 0
          ? <p style={{ color:'#64748b', fontSize:13, margin:0 }}>Sin contactos registrados. Agregá los contactos del cliente para poder elegirlos al enviar correos.</p>
          : (
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
              <thead><tr>{['Nombre','Cargo','Email','Teléfono',''].map(h => <th key={h} style={s.cth}>{h}</th>)}</tr></thead>
              <tbody>
                {contactos.map(c => (
                  <tr key={c.id}>
                    <td style={{ ...s.ctd, fontWeight:600, color:'#e2e8f0' }}>{c.nombre}</td>
                    <td style={s.ctd}>{c.cargo || '—'}</td>
                    <td style={{ ...s.ctd, color:'#93c5fd' }}>{c.email || '—'}</td>
                    <td style={s.ctd}>{c.telefono || '—'}</td>
                    <td style={{ ...s.ctd, whiteSpace:'nowrap' }}>
                      <button style={{ ...s.btnSec, padding:'2px 8px' }} onClick={() => setCtForm({ ...c })}>✏️</button>
                      <button style={{ ...s.btnSec, borderColor:'#7f1d1d', color:'#fca5a5', padding:'2px 8px', marginLeft:6 }} onClick={() => borrarContacto(c.id)}>✕</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/* Pestañas archivador */}
      <div style={s.tabs}>
        {TABS.map(t => (
          <button key={t.k} style={{ ...s.tab, ...(tab === t.k ? s.tabActive : {}) }} onClick={() => setTab(t.k)}>{t.label}</button>
        ))}
      </div>

      <div style={s.tabBody}>
        {tab === 'cotizaciones' && (
          <DocTable rows={cotis} cols={['Número','Fecha','Vence','Total','Estado']}
            render={c => [c.numero, fdate(c.fecha_emision), fdate(c.fecha_vencimiento), fmt(c.total), <Badge e={c.estado} />]}
            onRow={c => navigate(`/cotizaciones/${c.id}`)} empty="Sin cotizaciones para este cliente." />
        )}
        {tab === 'facturas' && (
          <DocTable rows={facturas} cols={['Número','Fecha','Total','Saldo','Estado']}
            render={f => [f.numero, fdate(f.fecha_emision), fmt(f.total), fmt(f.saldo), <Badge e={f.estado} />]}
            onRow={f => navigate(`/facturacion/${f.id}`)} empty="Sin facturas para este cliente." />
        )}
        {tab === 'remisiones' && (
          <DocTable rows={remis} cols={['Número','Fecha','Proyecto','Estado']}
            render={r => [r.numero, fdate(r.fecha_entrega), r.proyecto_nombre || '—', <Badge e={r.estado} />]}
            onRow={r => navigate('/remisiones')} empty="Sin remisiones para este cliente." />
        )}
        {tab === 'siigo' && (
          <div>
            <div style={{ display:'flex', gap:8, marginBottom:12 }}>
              {['factura','cotizacion'].map(t => (
                <button key={t} style={{ ...s.subTab, ...(sTipo === t ? s.tabActive : {}) }} onClick={() => setSTipo(t)}>
                  {t === 'factura' ? 'Facturas Siigo' : 'Cotizaciones Siigo'}
                </button>
              ))}
            </div>
            <HistorialSiigo tipo={sTipo} clienteNit={cliente.nit} />
          </div>
        )}
      </div>

      {editCli && (
        <div style={s.overlay} onClick={() => !savingCli && setEditCli(null)}>
          <div style={s.editModal} onClick={e => e.stopPropagation()}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:14 }}>
              <h2 style={{ ...s.h1, fontSize:18, margin:0 }}>Editar cliente</h2>
              <button style={s.back} onClick={() => setEditCli(null)}>✕</button>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
              <div style={{ gridColumn:'1 / -1' }}><label style={s.lbl}>Razón social *</label><input style={s.inp} value={editCli.razon_social||''} onChange={e => setEditCli({ ...editCli, razon_social:e.target.value })} /></div>
              <div><label style={s.lbl}>NIT</label><input style={s.inp} value={editCli.nit||''} onChange={e => setEditCli({ ...editCli, nit:e.target.value })} /></div>
              <div><label style={s.lbl}>Teléfono (celular 10 díg. para WhatsApp)</label><input style={s.inp} value={editCli.telefono||''} onChange={e => setEditCli({ ...editCli, telefono:e.target.value })} placeholder="3001234567" /></div>
              <div><label style={s.lbl}>Email</label><input style={s.inp} type="email" value={editCli.email||''} onChange={e => setEditCli({ ...editCli, email:e.target.value })} /></div>
              <div><label style={s.lbl}>Ciudad</label><input style={s.inp} value={editCli.ciudad||''} onChange={e => setEditCli({ ...editCli, ciudad:e.target.value })} /></div>
              <div style={{ gridColumn:'1 / -1' }}><label style={s.lbl}>Dirección</label><input style={s.inp} value={editCli.direccion||''} onChange={e => setEditCli({ ...editCli, direccion:e.target.value })} /></div>
              <div><label style={s.lbl}>Contacto</label><input style={s.inp} value={editCli.contacto_nombre||''} onChange={e => setEditCli({ ...editCli, contacto_nombre:e.target.value })} /></div>
              <div><label style={s.lbl}>Cargo del contacto</label><input style={s.inp} value={editCli.contacto_cargo||''} onChange={e => setEditCli({ ...editCli, contacto_cargo:e.target.value })} /></div>
            </div>
            <div style={{ display:'flex', gap:8, justifyContent:'flex-end', marginTop:16 }}>
              <button style={s.btnSec} onClick={() => setEditCli(null)} disabled={savingCli}>Cancelar</button>
              <button style={{ ...s.btnSm, opacity:savingCli?0.7:1 }} onClick={guardarCliente} disabled={savingCli}>{savingCli ? 'Guardando…' : 'Guardar'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const Info = ({ label, value }) => (
  <div style={{ display:'flex', justifyContent:'space-between', padding:'5px 0', borderBottom:'1px solid #1e293b' }}>
    <span style={{ color:'#64748b', fontSize:12 }}>{label}</span>
    <span style={{ color:'#e2e8f0', fontSize:13, textAlign:'right' }}>{value || '—'}</span>
  </div>
);
const Stat = ({ label, value, color, small }) => (
  <div style={s.statBox}>
    <div style={{ fontSize: small ? 15 : 24, fontWeight:700, color }}>{value}</div>
    <div style={{ fontSize:11, color:'#64748b' }}>{label}</div>
  </div>
);
const Badge = ({ e }) => <span style={{ background:(EC[e]||'#64748b')+'22', color:EC[e]||'#94a3b8', borderRadius:6, padding:'2px 8px', fontSize:11 }}>{e}</span>;

const DocTable = ({ rows, cols, render, onRow, empty }) => (
  <div style={{ overflowX:'auto' }}>
    <table style={s.table}>
      <thead><tr>{cols.map(c => <th key={c} style={s.th}>{c}</th>)}</tr></thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={r.id || i} style={{ ...s.tr, cursor:'pointer' }} onClick={() => onRow(r)}>
            {render(r).map((cell, j) => <td key={j} style={{ ...s.td, ...(j === 0 ? { color:'#93c5fd', fontWeight:500 } : {}) }}>{cell}</td>)}
          </tr>
        ))}
        {rows.length === 0 && <tr><td colSpan={cols.length} style={{ ...s.td, textAlign:'center', padding:24, color:'#64748b' }}>{empty}</td></tr>}
      </tbody>
    </table>
  </div>
);

const s = {
  btnSm:  { background:'#1d4ed8', color:'#fff', border:'none', borderRadius:6, padding:'6px 12px', fontSize:13, fontWeight:600, cursor:'pointer' },
  btnSec: { background:'#334155', color:'#cbd5e1', border:'1px solid #475569', borderRadius:6, padding:'6px 12px', fontSize:13, cursor:'pointer' },
  lbl:    { display:'block', fontSize:11, color:'#94a3b8', marginBottom:3 },
  inp:    { width:'100%', boxSizing:'border-box', padding:'7px 9px', background:'#1e293b', border:'1px solid #334155', borderRadius:6, color:'#e2e8f0', fontSize:13 },
  cth:    { textAlign:'left', padding:'6px 8px', color:'#64748b', fontSize:11, textTransform:'uppercase', letterSpacing:.5, borderBottom:'1px solid #334155' },
  ctd:    { padding:'7px 8px', color:'#94a3b8', borderBottom:'1px solid #1e293b' },
  back: { background:'none', border:'none', color:'#7dd3fc', cursor:'pointer', fontSize:13, padding:0, marginBottom:12 },
  head: { marginBottom:16 },
  h1: { fontSize:24, fontWeight:700, color:'#f1f5f9', margin:'0 0 2px' },
  sub: { color:'#64748b', fontSize:13, margin:0 },
  topGrid: { display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:20 },
  card: { background:'#1e293b', borderRadius:12, border:'1px solid #334155', padding:20 },
  cardTitle: { color:'#f1f5f9', fontSize:14, fontWeight:600, margin:'0 0 12px' },
  stats: { display:'flex', gap:16, flexWrap:'wrap' },
  statBox: { background:'#0f172a', border:'1px solid #334155', borderRadius:10, padding:'12px 16px', textAlign:'center', minWidth:100, flex:1 },
  tabs: { display:'flex', gap:4, borderBottom:'1px solid #334155', marginBottom:16, flexWrap:'wrap' },
  tab: { background:'transparent', border:'none', borderBottom:'2px solid transparent', color:'#94a3b8', borderRadius:'6px 6px 0 0', padding:'10px 16px', fontSize:13, cursor:'pointer' },
  tabActive: { background:'#1e3a5f', border:'1px solid #3b82f6', color:'#7dd3fc', borderRadius:6 },
  subTab: { background:'#0f172a', border:'1px solid #334155', color:'#94a3b8', borderRadius:8, padding:'6px 14px', fontSize:13, cursor:'pointer' },
  tabBody: {},
  table: { width:'100%', borderCollapse:'collapse', fontSize:13 },
  th: { color:'#64748b', fontSize:11, fontWeight:600, textAlign:'left', padding:'0 10px 10px', textTransform:'uppercase' },
  tr: { borderTop:'1px solid #334155' },
  td: { padding:'6px 10px', color:'#94a3b8' },
  overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,.6)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, padding:16 },
  editModal: { background:'#1e293b', border:'1px solid #334155', borderRadius:12, padding:22, width:560, maxWidth:'96vw', maxHeight:'92vh', overflowY:'auto' },
};
